import { combineReducers } from 'redux'
import { availableCategoriesReducer as availableCategories } from '../modules/availableCategories'
import { categoriesReducer as categories } from '../modules/categories'
import { pricesReducer as prices } from '../modules/prices'
import { secretKeyReducer as secretKey } from '../modules/secretKey'
import { shoppingCartReducer as shoppingCart } from '../modules/shoppingCart'
import { propertiesReducer as properties } from '../modules/properties'
import { createOrderReducer as orderStatus } from '../modules/createOrder'

export default combineReducers({
    availableCategories,
    categories,
    secretKey,
    shoppingCart,
    prices,
    properties,
    orderStatus
})



// WEBPACK FOOTER //
// ./reducers/index.js